import "./ui.css";

/** Sichtbare Kennzeichnung; die Pflicht-Semantik trägt das jeweilige Control. */
export function RequiredMark() {
  return (
    <span className="ui-required-mark" aria-hidden="true">
      Pflicht
    </span>
  );
}
